import { CustomTable } from '@/components/Table';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { EventPdvSaleProductReport } from '@/model/EventPdvSaleProductReport';
import React, { Fragment } from 'react';
import SuperCollapse from '@/components/sharedComponents/SuperCollapse';
import { ReportDropdownHeader } from '../../ReportDropdownHeader';

interface StateProps {
  pdvs: EventPdvSaleProductReport[];
}

export const SaleProductPdvContent: React.FC<StateProps> = ({ pdvs }): JSX.Element => (
  <Fragment>
    {pdvs.map(data => (
      <div key={data.id} className="mb-3">
        <SuperCollapse
          title={
            <ReportDropdownHeader
              title={`PDV: ${data.name}`}
              summary={data.summary}
              payments={data.payments}
            />
          }
          content={
            <div className="p-3 bg-white rounded">
              {data.sections.map(section => (
                <Fragment key={section.id}>
                  {section.categories.map(category => (
                    <div key={category.id} className="mb-4">
                      <h6 className="font-weight-bold mb-2 text-secondary">{`${section.name} - ${category.name}`}</h6>
                      <CustomTable
                        theme="secondaryWithoutBorder"
                        numberRowsPerPage={0}
                        progressPending={false}
                        columns={[
                          {
                            name: 'Produto/Combo',
                            selector: row => row.productName,
                          },
                          {
                            name: 'Vendidos',
                            selector: row => row.productSold,
                          },
                          {
                            name: 'Estoque inicial',
                            selector: row => row.initialInventory,
                          },
                          {
                            name: 'Estoque disponível',
                            selector: row => row.availableStock,
                          },
                          {
                            name: 'Valor',
                            selector: row => row.unitValue,
                          },
                          {
                            name: 'Venda',
                            selector: row => row.totalSaleValue,
                          },
                          {
                            name: 'Comissão',
                            selector: row => row.totalCommission,
                          },
                          {
                            name: 'Venda + Comissão',
                            selector: row => row.totalSaleWithCommission,
                          },
                        ]}
                        data={
                          category.products.map(product => ({
                            productName: product.name,
                            productSold: product.amountSold,
                            initialInventory: product.initialInventory,
                            availableStock: product.availableStock,
                            unitValue: toCurrency(product.unitValue),
                            totalSaleValue: toCurrency(product.totalSaleValue),
                            totalCommission: toCurrency(product.totalCommission),
                            totalSaleWithCommission: toCurrency(product.totalSaleWithCommission),
                          })) || []
                        }
                      />
                    </div>
                  ))}
                </Fragment>
              ))}
            </div>
          }
        />
      </div>
    ))}
  </Fragment>
);
